import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, BrowserBackGuard } from 'cbc-shared-lib';
import { Sgkb701dComponent } from './pages/sgkb701d/pages/sgkb701d/sgkb701d.component';
import { Sgkb708dComponent } from './pages/sgkb708d/pages/sgkb708d/sgkb708d.component';
import { Sgkb713dComponent } from './pages/sgkb713d/pages/sgkb713d/sgkb713d.component';
import { Sgkb714dComponent } from './pages/sgkb714d/pages/sgkb714d/sgkb714d.component';
import { Sgkb941dComponent } from './pages/sgkb941d/pages/sgkb941d/sgkb941d.component';
import { Sgkb980dComponent } from './pages/sgkb980d/pages/sgkb980d/sgkb980d.component';
import { Sgkb106dComponent } from './pages/sgkb106d/pages/sgkb106d/sgkb106d.component';
import { Sgkb122dComponent } from './pages/sgkb122d/pages/sgkb122d/sgkb122d.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canDeactivate: [BrowserBackGuard],
    children: [
      { path: 'sgkb701d', component: Sgkb701dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkb708d', component: Sgkb708dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkb713d', component: Sgkb713dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkb714d', component: Sgkb714dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkb941d', component: Sgkb941dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkb980d', component: Sgkb980dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkb106d', component: Sgkb106dComponent, canDeactivate: [BrowserBackGuard] },
      { path: 'sgkb122d', component: Sgkb122dComponent, canDeactivate: [BrowserBackGuard] },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SgKbMainRoutingModule { }
